import { consola } from 'consola'
import { Capacitor } from '@capacitor/core'

/**
 * Утилита для определения платформы приложения
 */
export const PlatformHelper = {
  /**
   * Проверка, запущено ли приложение в Capacitor (мобильное приложение)
   */
  isCapacitor(): boolean {
    if (!process.client) return false
    return Capacitor.isNativePlatform()
  },

  /**
   * Проверка, запущено ли приложение в браузере
   */
  isBrowser(): boolean {
    if (!process.client) return false
    return !Capacitor.isNativePlatform()
  },

  /**
   * Получить название платформы
   */
  getPlatformName(): 'web' | 'ios' | 'android' {
    if (!process.client) return 'web'
    const platform = Capacitor.getPlatform()
    return platform as 'web' | 'ios' | 'android'
  },

  /**
   * Получить заголовки для API запросов, специфичные для платформы
   */
  getApiHeaders(): Record<string, string> {
    if (!process.client) return {}
    
    const headers: Record<string, string> = {}
    
    // Добавляем заголовок для идентификации Capacitor приложения
    if (this.isCapacitor()) {
      headers['X-Client-Platform'] = 'capacitor'
      headers['X-Platform-Type'] = this.getPlatformName()
      
      if (process.dev) {
        consola.debug('📱 [PlatformHelper] Capacitor detected:', {
          platform: this.getPlatformName(),
          headers,
        })
      }
    } else {
      headers['X-Client-Platform'] = 'web'
      
      if (process.dev) {
        consola.debug('🌐 [PlatformHelper] Web platform detected')
      }
    }
    
    return headers
  },
};

// Экспортируем удобные функции
export const isCapacitor = () => PlatformHelper.isCapacitor()
export const isBrowser = () => PlatformHelper.isBrowser()
export const getPlatformName = () => PlatformHelper.getPlatformName()
export const getPlatformApiHeaders = () => PlatformHelper.getApiHeaders()

